export default function Marquee({ items, duration = "42s" }) {
  const row = (ariaHidden) => (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display italic text-2xl md:text-3xl text-cream/80 whitespace-nowrap px-6">{item}</span>
          <svg width="10" height="10" viewBox="0 0 10 10" className="shrink-0">
            <path d="M5 0 L10 5 L5 10 L0 5 Z" fill="#A78BFA" />
          </svg>
        </span>
      ))}
    </div>
  );
  return (
    <div
      className="marquee-mask overflow-hidden border-y border-white/10 bg-moss py-6"
      style={{ "--marquee-duration": duration }}
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
}
